import invariant from "./invariant";

const GA_TRACKING_ID: string = process.env.GATSBY_GOOGLE_ANALYTICS_TRACKING_ID!;

invariant(
  !!GA_TRACKING_ID,
  "GATSBY_GOOGLE_ANALYTICS_TRACKING_ID must be loaded"
);

export const loadGoogleAnalytics = (): void => {
  window.ga =
    window.ga ||
    function () {
      // eslint-disable-next-line prefer-rest-params
      (window.ga.q = window.ga.q || []).push(arguments);
    };
  window.ga.l = +new Date();
  window.ga("create", GA_TRACKING_ID, "auto");
};

/**
 *
 * @param {string} send
 * @param {string} event
 * @param {string} eventCategory
 * @param {string} eventAction
 * @param {string} eventLabel
 * @param {string} eventValue
 */
export const logGoogleAnalyticsEvent = (
  send: "send",
  event: "event" | "pageview",
  eventCategory: string,
  eventAction?: string,
  eventLabel?: string,
  eventValue?: number
): void => {
  if (typeof window.ga !== "function") {
    loadGoogleAnalytics();
  }
  window.ga(send, event, eventCategory, eventAction, eventLabel, eventValue);
};
